export default __webpack_public_path__ + "static/media/italy.2b31e5a9.svg";